import { useQuery, useQueryClient } from "@tanstack/react-query";
import { qoGamificationStats, IGamificationStats } from "../utils/queryOptions";

export function useGamification() {
  const queryClient = useQueryClient();
  const { data: stats, isSuccess, isLoading } = useQuery(qoGamificationStats());

  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: ["gamificationStats"] });
  };

  const updateCache = (partial: Partial<IGamificationStats>) => {
    queryClient.setQueryData<IGamificationStats>(
      ["gamificationStats"],
      (old) => (old ? { ...old, ...partial } : undefined) as IGamificationStats
    );
  };

  return {
    stats: stats ?? {
      totalXp: 0,
      currentStreak: 0,
      longestStreak: 0,
      freezeCount: 0,
      freezeInUse: 0,
      level: 1,
      levelProgress: 0,
      xpToNextLevel: 50,
    },
    isSuccess,
    isLoading,
    invalidate,
    updateCache,
  };
}
